exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.file-type-email[data-v-6ea6db6c] {\n  color: #0072C6;\n}\n.file-type-excel[data-v-6ea6db6c] {\n  color: #1D6F42;\n}\n.file-type-pdf[data-v-6ea6db6c] {\n  color: #F40F02;\n}\n.file-type-word[data-v-6ea6db6c] {\n  color: #00a2ed;\n}\n.file-type-default[data-v-6ea6db6c] {\n  color: #333333;\n}\n", ""]);

// exports
